<template>
  <div>
    <div class="pageheader">
      <nav>
        <div class="logo">
          <a href="/">
            <img src="@/assets/images/_logo.png" alt="novaLab" />
            <p>NOBA LAB</p>
          </a>
        </div>
        <div class="nav-menu">
          <ul class="mainMenu">
            <li>
              <router-link
                to="/audio/noiseCancel"
                :class="{ active: navbarState == 0 ? true : false }"
                alt="noise reduction"
              >{{ $t("nr") }}</router-link>
            </li>
            <li>
              <router-link
                to="/audio/recording"
                :class="{ active: navbarState == 1 ? true : false }"
                alt="recording"
              >{{ $t("recording") }}</router-link>
            </li>
            <!-- <li>
              <a href="/storage" alt="녹음">스토리지</a>
            </li>-->
            <li>
              <router-link
                to="/audio/encoding"
                :class="{ active: navbarState == 2 ? true : false }"
                alt="encoding"
              >{{ $t("encoding") }}</router-link>
            </li>
            <li>
              <router-link
                to="/audio/editor"
                :class="{ active: navbarState == 3 ? true : false }"
                alt="edit"
              >{{ $t("edit") }}</router-link>
            </li>
            <li>
              <router-link
                to="/checkout/pricing"
                :class="{ active: navbarState == 4 ? true : false }"
                alt="pricing"
              >{{ $t("pricing") }}</router-link>
            </li>
          </ul>
          <ul class="accountMenu">
            <li>
              <a
                v-click-outside="hide"
                v-show="isLogin"
                @click="toggle"
                alt="user"
              >{{ $store.getters.username }}</a>
              <div v-show="opened">
                <ul class="subMenu" id="subMenu">
                  <li>
                    <button type="button" @click="handleMove('me')">{{ $t("mypage") }}</button>
                  </li>
                  <!-- <li>
                    <button type="button" @click="handleMove('edit')">
                      계정관리
                    </button>
                  </li>-->
                  <li>
                    <button type="button" @click="handleMove('pricing')">프리미엄</button>
                  </li>
                  <li>
                    <button v-if="isLogin" type="button" @click="handleLog">{{ $t("logout") }}</button>
                    <button v-else type="button" @click="handleLog">{{ $t("login") }}</button>
                  </li>
                </ul>
              </div>
            </li>
            <li v-if="isLogin">
              <router-link @click="handleLog" alt="logout">{{ $t("logout") }}</router-link>
            </li>
            <li v-else>
              <router-link to="/account/login" alt="login">{{ $t("login") }}</router-link>
            </li>
            <li>
              <a @click="handleLanguage" alt="language">{{ $t("language") }}</a>
            </li>
          </ul>
        </div>
        <div class="burger" @click="navSlide">
          <div class="line1"></div>
          <div class="line2"></div>
          <div class="line3"></div>
        </div>
      </nav>
    </div>
    <transition name="fade">
      <div v-if="visible" class="dim on">
        <SelectLanguage />
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { eventBus } from "../main";
import ClickOutside from "vue-click-outside";
import SelectLanguage from "@/components/modal/SelectLanguage";
export default {
  name: "Navbar",
  components: { SelectLanguage },
  directives: {
    ClickOutside
  },
  data() {
    return {
      visible: false,
      opened: false
    };
  },
  computed: {
    ...mapState(["userInfo", "isLogin", "navbarState"])
  },
  mounted() {
    this.initFacebook();
    eventBus.$on("closeModal", () => {
      this.closeModal();
    });
    this.popupItem = this.$el;
  },
  methods: {
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },
    async initFacebook() {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: "461547038186504", //You will need to change this
          cookie: true, // This is important, it's not enabled by default
          xfbml: true,
          version: "v9.0"
        });
      };
    },
    facebookLogout() {
      window.console.log("facebookLogout");
      window.FB.getLoginStatus(response => {
        window.console.log("response", response);
        window.FB.logout(res => {
          window.console.log("res", res);
          this.$store.dispatch("LOGOUT");
        });
      });
    },
    navSlide() {
      const nav = document.querySelector(".nav-menu");
      nav.classList.toggle("nav-active");
    },
    ...mapActions(["LOGOUT"]),
    async handleLog() {
      if (this.isLogin == true) {
        let result = confirm(this.$t("logout_confirm"));
        if (result) {
          if (this.userInfo.type == "FACEBOOK") {
            this.$store.dispatch("LOGOUT");
          } else if (this.userInfo.type == "GOOGLE") {
            let auth2 = window.gapi.auth2.getAuthInstance();
            auth2.signOut().then(() => {
              this.$store.dispatch("LOGOUT");
            });
          } else {
            let auth2 = window.gapi.auth2.getAuthInstance();
            auth2.signOut().then(() => {
              this.$store.dispatch("LOGOUT");
            });
          }
        }
      } else {
        this.$router.push({ name: "login" });
      }
    },
    hide() {
      this.opened = false;
    },
    toggle() {
      this.opened = !this.opened;
      window.console.log("opened".this.opened);
    },
    closeModal() {
      this.visible = false;
    },
    handleMove(type) {
      if (type == "me") {
        this.$router.push("/account/me");
      } else if (type == "edit") {
        this.$router.push("/account/me/edit");
      } else if (type == "pricing") {
        this.$router.push("/checkout/pricing");
      }
    },
    handleLanguage() {
      this.visible = !this.visible;
      const nav = document.querySelector(".nav-menu");
      nav.classList.toggle("nav-active");
    }
  }
};
</script>
<style scoped>
.active {
  color: red;
}
</style>